var cov_24blb1akwi = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Button/Group.tsx",
      hash = "43ea5d95a95d8c396cd5332e6c5a9042e770bcf7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Button/Group.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 53
        },
        end: {
          line: 15,
          column: 63
        }
      },
      "1": {
        start: {
          line: 17,
          column: 23
        },
        end: {
          line: 17,
          column: 41
        }
      },
      "2": {
        start: {
          line: 18,
          column: 22
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "3": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      "4": {
        start: {
          line: 26,
          column: 10
        },
        end: {
          line: 26,
          column: 92
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 40
          },
          end: {
            line: 25,
            column: 41
          }
        },
        loc: {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 92
          }
        },
        line: 26
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 27
          },
          end: {
            line: 19,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 28
          },
          end: {
            line: 19,
            column: 35
          }
        }, {
          start: {
            line: 19,
            column: 39
          },
          end: {
            line: 19,
            column: 50
          }
        }, {
          start: {
            line: 19,
            column: 55
          },
          end: {
            line: 19,
            column: 64
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 66
          },
          end: {
            line: 19,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 66
          },
          end: {
            line: 19,
            column: 73
          }
        }, {
          start: {
            line: 19,
            column: 77
          },
          end: {
            line: 19,
            column: 88
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 26,
            column: 53
          },
          end: {
            line: 26,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 66
          },
          end: {
            line: 26,
            column: 70
          }
        }, {
          start: {
            line: 26,
            column: 73
          },
          end: {
            line: 26,
            column: 89
          }
        }],
        line: 26
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Button/Group.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Children, PureComponent, cloneElement } from 'react';
import classnames from 'classnames';
import { buttonClass } from './styles';
import { isRTL } from '../config';

var ButtonGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ButtonGroup, _PureComponent);

  var _super = _createSuper2(ButtonGroup);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _super.apply(this, arguments);
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      cov_24blb1akwi.f[0]++;

      var _ref = (cov_24blb1akwi.s[0]++, this.props),
          children = _ref.children,
          outline = _ref.outline,
          size = _ref.size,
          type = _ref.type,
          style = _ref.style;

      var typeSetted = (cov_24blb1akwi.s[1]++, type !== 'default');
      var className = (cov_24blb1akwi.s[2]++, classnames(buttonClass('group', ((cov_24blb1akwi.b[0][0]++, outline) || (cov_24blb1akwi.b[0][1]++, !typeSetted)) && (cov_24blb1akwi.b[0][2]++, 'outline'), (cov_24blb1akwi.b[1][0]++, isRTL()) && (cov_24blb1akwi.b[1][1]++, 'group-rtl')), this.props.className));
      cov_24blb1akwi.s[3]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 7
          }
        }, Children.toArray(children).map(function (child) {
          cov_24blb1akwi.f[1]++;
          cov_24blb1akwi.s[4]++;
          return (
            /*#__PURE__*/
            cloneElement(child, {
              size: size,
              outline: outline,
              type: typeSetted ? (cov_24blb1akwi.b[2][0]++, type) : (cov_24blb1akwi.b[2][1]++, child.props.type)
            })
          );
        }))
      );
    }
  }]);

  return ButtonGroup;
}(PureComponent);

ButtonGroup.defaultProps = {
  outline: false,
  type: 'default'
};
export default ButtonGroup;